import { render } from "./RecycleHistoryItem.vue?vue&type=template&id=f68b2050&scoped=true"
import script from "./RecycleHistoryItem.vue?vue&type=script&lang=ts"
export * from "./RecycleHistoryItem.vue?vue&type=script&lang=ts"

import "./RecycleHistoryItem.vue?vue&type=style&index=0&id=f68b2050&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-f68b2050"

export default script